import React, { useState } from 'react';
import { Checkbox, TableCell, TableRow, Tooltip, Box, Chip } from '@mui/material';
import { Restore as RestoreIcon, Visibility as VisibilityIcon, Edit as EditIcon, Delete as DeleteIcon, AttachFile } from '@mui/icons-material';
import LessMoreComp from '../../../../shared_elements/components/CustomLessMoreComp';
import PermissionWrapper from '../../../../wrappers/PermissionWrapper';
import { trackActivity } from '../../../../utils/mixpanel';
import UploadingIcon from '../../../../shared_elements/components/UploadingIcon';
import AuditPopover from '../../../../shared_elements/components/popover';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const MembersList = ({ item, key, uploadedFileData, uploadFileProgressData, slug, viewFileStatus, onEditFn, onView, viewRevisonHistory, onDeleteMember, onOpenAttachments, toggleBulkOps, bulk }) => {

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Working Group Members Listing`, page_type: page_type, })
    }
    return (
        <TableRow key={key}>
            <TableCell className="table-actions-list">
                <Box className="table-icon-container">
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "working_groups", operationType: ['D'] }}>
                    <Checkbox sx={{ verticalAlign: 'super' }} color="primary" size="small" checked={bulk?.ids?.find(items => items?.id === item?.id) ? true : false} onChange={toggleBulkOps} />
                        </PermissionWrapper>
                    <AuditPopover item={item}>
                        <MoreVertIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} />
                    </AuditPopover>
                    <Tooltip title="Revision History"><RestoreIcon className='revision-history' onClick={()=>{viewRevisonHistory(item);handleItemClicked('RevisionHistoryIcon')}} sx={{ cursor: "pointer" }} fontSize='small' color='primary' /></Tooltip>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "working_groups", operationType: ['R'] }}>
                    <Tooltip title="View"><VisibilityIcon onClick={()=>{onView();handleItemClicked('ViewIcon')}} sx={{ cursor: "pointer" }} fontSize='small' color='primary' /></Tooltip>
                    </PermissionWrapper>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "working_groups", operationType: ['U'] }}>
                    <Tooltip title="Edit"><EditIcon onClick={()=>{onEditFn();handleItemClicked('EditIcon')}} sx={{ cursor: "pointer" }} fontSize='small' color='primary' /></Tooltip>
                    </PermissionWrapper>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "working_groups", operationType: ['D'] }}>
                    <Tooltip title="Delete"><DeleteIcon onClick={()=>{onDeleteMember();handleItemClicked('DeleteIcon')}} sx={{ cursor: "pointer" }} fontSize='small' color='error' /></Tooltip>
                    </PermissionWrapper>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "working_groups", operationType: ['R'] }}>
                    {
                        item?.attachments?.length > 0 && (
                            <Tooltip title="Attached File(s)">
                                <Box className="attachment-container">
                                    <AttachFile fontSize="small" color="primary" onClick={()=>{onOpenAttachments();handleItemClicked('AttachmentsIcon')}} sx={{ cursor: "pointer" }} />
                                    <Box className="attachment-count"> ({item.attachments.length}) </Box>
                                </Box>
                            </Tooltip>
                        )
                    }
                    </PermissionWrapper>   
                  { (slug === item?.slug) && <UploadingIcon viewFileStatus={() => viewFileStatus(uploadedFileData)} /> }
                </Box>
            </TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>
                <div style={{ width: item?.first_name?.length > 50 ? "200px" : '' }}><LessMoreComp name={item?.first_name} lessMr='first_name' /></div>
                {item?.default_mailer && (
                    <Chip
                        size="small"
                        variant="outlined"
                        label="Default Mail Receiver"
                        sx={{ fontSize: '10px', height: '18px' }}
                    />
                )}
            </TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><div style={{ width: item?.last_name?.length > 50 ? "200px" : ''}}><LessMoreComp name={item?.last_name} lessMr='last_name' /></div></TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.email || '--'}</TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.mobile || '--'}</TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.designation || '--'}</TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><div style={{ width: item?.remarks?.length > 50 ? "300px" : ''}}><LessMoreComp name={item?.remarks} lessMr='remarks' /></div></TableCell>
        </TableRow>
    )
}
export default MembersList;